/** Ключи React Query: строковые константы, без склейки «на месте». */

export const queryKeys = {
  me: ['me'] as const,

  projects: {
    all: ['projects'] as const,
    list: (archived: string) => ['projects', 'list', archived] as const,
    detail: (key: string) => ['projects', 'detail', key] as const,
    members: (key: string) => ['projects', key, 'members'] as const,
    workflow: (key: string) => ['projects', key, 'workflow'] as const,
    /** Список workflow проекта с привязкой типов задач (docs/03 §1). */
    workflows: (key: string) => ['projects', key, 'workflows'] as const,
    /** Конкретный workflow: колонки доски берутся из своего набора. */
    workflowById: (key: string, workflowId: string) =>
      ['projects', key, 'workflow', workflowId] as const,
    sprints: (key: string, state: string) => ['projects', key, 'sprints', state] as const,
    /** Список досок проекта: питает вложенное меню «Доски» (docs/06 §2). */
    boards: (key: string) => ['projects', key, 'boards'] as const,
    /** Компоненты проекта: справочник для настроек и полей задачи (docs/13 §7). */
    components: (key: string, includeArchived = false) =>
      ['projects', key, 'components', includeArchived ? 'all' : 'active'] as const,
    /** Токены публичного API проекта (docs/12 §Приложение A.1). */
    apiTokens: (key: string) => ['projects', key, 'api-tokens'] as const,
    /** Репозиторий проекта: URL, ветка и наличие токена (docs/17 §5.5). */
    repository: (key: string) => ['projects', key, 'repository'] as const,
    /** Wiki: дерево страниц и журнал обмена (docs/14). */
    wikiPages: (key: string) => ['projects', key, 'wiki', 'pages'] as const,
    wikiPage: (key: string, pageId: string) =>
      ['projects', key, 'wiki', 'page', pageId] as const,
    wikiVersions: (key: string, pageId: string) =>
      ['projects', key, 'wiki', 'versions', pageId] as const,
    wikiComments: (key: string, pageId: string) =>
      ['projects', key, 'wiki', 'comments', pageId] as const,
    wikiAttachments: (key: string, pageId: string) =>
      ['projects', key, 'wiki', 'attachments', pageId] as const,
    wikiTransfers: (key: string) => ['projects', key, 'wiki', 'transfers'] as const,
    wikiSearch: (key: string, query: string) =>
      ['projects', key, 'wiki', 'search', query] as const,
  },

  board: {
    root: (projectKey: string) => ['projects', projectKey, 'board'] as const,
    view: (projectKey: string, filters: string) =>
      ['projects', projectKey, 'board', filters] as const,
  },

  /** Персональная доска «Мои задачи» (E18): префиксный корень для инвалидации. */
  personalBoard: {
    root: ['my', 'board'] as const,
    view: (filters: string) => ['my', 'board', filters] as const,
  },

  backlog: {
    /**
     * Корень бэклога. Все инвалидации идут по нему — префиксная выборка
     * React Query захватывает и страницы с явным `limit`.
     */
    view: (projectKey: string) => ['projects', projectKey, 'backlog'] as const,
    /** Конкретная порция: бэклог подгружается частями, ключ зависит от лимита. */
    page: (projectKey: string, limit: number) =>
      ['projects', projectKey, 'backlog', limit] as const,
  },

  issues: {
    all: ['issues'] as const,
    detail: (key: string) => ['issues', key] as const,
    transitions: (key: string) => ['issues', key, 'transitions'] as const,
    comments: (key: string) => ['issues', key, 'comments'] as const,
    attachments: (key: string) => ['issues', key, 'attachments'] as const,
    changelog: (key: string) => ['issues', key, 'changelog'] as const,
    subtasks: (key: string) => ['issues', key, 'subtasks'] as const,
    search: (jql: string, offset: number) => ['issues', 'search', jql, offset] as const,
  },

  quickSearch: (q: string) => ['search', 'quick', q] as const,
  jqlValidate: (jql: string) => ['jql', 'validate', jql] as const,
  filters: ['filters'] as const,

  notifications: {
    all: ['notifications'] as const,
    list: (offset: number) => ['notifications', 'list', offset] as const,
    unreadCount: ['notifications', 'unread-count'] as const,
    watchers: (issueKey: string) => ['issues', issueKey, 'watchers'] as const,
  },

  reports: {
    summary: (key: string, days: number) => ['projects', key, 'reports', 'summary', days] as const,
    burndown: (key: string, sprintId: string) =>
      ['projects', key, 'reports', 'burndown', sprintId] as const,
    velocity: (key: string) => ['projects', key, 'reports', 'velocity'] as const,
  },

  agents: {
    all: ['agents'] as const,
    list: ['agents', 'list'] as const,
    setup: (id: string) => ['agents', 'setup', id] as const,
    install: (id: string) => ['agents', 'install', id] as const,
    skills: (id: string) => ['agents', 'skills', id] as const,
  },

  admin: {
    users: (q: string, status: string, offset: number) =>
      ['admin', 'users', q, status, offset] as const,
    user: (id: string) => ['admin', 'users', id] as const,
    audit: (filters: string) => ['admin', 'audit', filters] as const,
    /** Приглашения: корень нужен для префиксной инвалидации. */
    invitations: ['admin', 'invitations'] as const,
    invitationList: (status: string, offset: number) =>
      ['admin', 'invitations', 'list', status, offset] as const,
    mail: ['admin', 'mail'] as const,
  },
} as const;
